import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=2b92f82a"
import script from "./chats.vue?vue&type=script&lang=js"
export * from "./chats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports